import { useCallback } from 'react'

export interface RouteDatesProps {
  deliveryDate: string
  pickup?: boolean
  pickupDate: string
  routeNumber: number
}

const dateFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as Intl.DateTimeFormatOptions

export default function RouteDates({
  deliveryDate,
  pickup = true,
  pickupDate,
}: RouteDatesProps) {
  const formatDate = useCallback((dateString: string): string => {
    const date = new Date(dateString + 'T00:00:00')
    return date.toLocaleDateString('en-US', dateFormatOptions)
  }, [])
  return (
    <div className="mb-2 lg:mb-0">
      <p>
        <strong>{pickup ? 'Pick up' : 'Drop off'}:</strong>{' '}
        {formatDate(pickupDate)}
      </p>
      <p>
        <strong>Delivery by:</strong> {formatDate(deliveryDate)}
      </p>
    </div>
  )
}
